import React, { Component, Fragment, useRef } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Counter from './components/Counter';
import Calendar from './components/Calendar';
import BookingModal from './components/BookingModal';
import BookingAirports from './components/BookingAirports';
import resizer from 'components/common/Resizer';
import FlipMove from 'react-flip-move';
import isWindow from 'components/common/helpers/isWindow';
import styled from 'styled-components'
import axios from 'components/AppRequest';
import { AIRPORT_FROM, AIRPORT_TO } from 'components/utils/airportTypes';
import { setChildrenNumber, setAdultsNumber, showSidebar, startFromBooking, setStudentsNumber }
  from 'components/actions/bookingActions';
import FirstStepValidation from './utils/FirstStepValidation';
import withRouter from 'components/components/common/withRouter';
import { Error } from 'components/common/Form.js';
import classNames from 'classnames';
import { Transition } from 'react-transition-group';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import _ from 'lodash';
import $ from 'jquery';

const duration = 400;

const defaultStyle = {
  transition: `all ${duration}ms cubic-bezier(0.075, 0.82, 0.165, 1)`,
  opacity: 0,
  transform: `translate(0,0)`,
}

const transitionStyles = {
  entering: { opacity: 1, transform: `translate(0,0)`, },
  entered: { opacity: 1, transform: `translate(0,0)`, },
  exiting: { opacity: 0, transform: `translate(-100%,0)`, },
  exited: { opacity: 0, transform: `translate(-100%,0)`, },
};

const SidebarArrow = styled.div`
	height: 60px !important;
	left: 100%;
	position: absolute;
	top: ${props => props.positionTop}px;
	width: 25px;
  z-index: ${props => props.visible ? '5' : '1'};
  overflow: hidden;
  transform: translate(${props => props.visible ? 0 : '-25px'}, 4px);
  transition: all 150ms ease-in-out;
  &:after{
    content: '';
    position: absolute;
    right: 10px;
    top: 15px;
    bottom: 0;
    display: block;
    height: 32px;
    width: 32px;
    transform: rotate(45deg);
    box-shadow: 0 0 10px 3px rgba(31, 93, 162, 0.07);
    background: white;
  }
`;

class BookingInput extends Component {
  render() {
    const {
      id,
      label,
      placeholder,
      defaultValue,
      toggleModal,
      children,
      className,
      value,
      name,
      readOnly,
      optional,
      locale
    } = this.props;

    return (
      <div className={className}>
        <label htmlFor={id}>
          {label}
          {this.props.optional &&
            <span>({TransHelper.translate(locale, 'content.common.optional')})</span>
          }
        </label>
        <div className="field-icon">
          <input
            type="text"
            id={id}
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            readOnly={readOnly}
            onClick={() => toggleModal()} />
          <label htmlFor={id}>
            {children && children}
          </label>
        </div>
      </div>
    );
  }
}

class Booking extends Component {

  state = {
    showDesktopChooseAirportFrom: false,
    showDesktopChooseAirportTo: false,
    showDesktopChooseDate: false,
    sidebarActive: false,
    airportType: '',
    height: 900,
    heightContainer: null,
    arrowPosition: 0,
    airports: [],
    errors: {},
    viewLP: false,
    inProp: false,
    hasMounted: false
  }

  componentDidMount() {
    this.setState({ hasMounted: true, height: window.innerHeight });

    this.props.showSidebar(false);
    axios.get('/pwa/reservation/airports')
      .then(response => {
        this.setState({ airports: response.data });
      })
      .catch(err => {
        console.log('err', err)
      });
  }

  componentWillUnmount() {
    this.props.showSidebar(true);
  }

  componentDidUpdate(prevProps) {
    var noErrors = _.isEmpty(this.state.errors);
    if (noErrors) {
      $('.booking__form-desc .amount-people').removeClass('error-margin');
    } else {
      $('.booking__form-desc .amount-people').addClass('error-margin');
    }
  }

  goNext = (e) => {
    e.preventDefault();
    //reset errors
    this.setState({ errors: {} });

    var validateObject = new FirstStepValidation(this.props);

    if (validateObject.isValidForm()) {
      if (typeof this.props.onlyMobile === "undefined") {
        var s = true;
      } else {
        var s = this.props.onlyMobile;
      }

      this.props.startFromBooking(s);

      if (this.props.childrenNumber > 0) {
        TransHelper.redirect(this.props, 'routes.url.kidsSafety');
      } else {
        TransHelper.redirect(this.props, 'routes.url.flights');
      }
    } else {
      this.setState({ errors: validateObject.getFieldsErrors() });
    }
  }

  setPositionArrow = (input) => {
    if (input) {
      const inputDOM = ReactDOM.findDOMNode(input);
      let inputPosition = inputDOM.getBoundingClientRect();
      this.setState({ arrowPosition: inputPosition.top });
    }
  }

  isMobile = () => {
    if (this.props.onlyMobile) {
      return true;
    } else {
      if (typeof this.props.onlyMobile === "undefined") {
        var width = 959;
      } else {
        var width = 768;
      }
      return this.props.windowWidth <= width;
    }
  }

  handleClickAirport = (airportType, input) => {
    this.setPositionArrow(input);

    this.setState({
      showDesktopChooseDate: false,
      sidebarActive: true,
      viewLP: true,
      airportType,
      inProp: false,
    }, () => this.props.showSidebar(this.state.sidebarActive));

    if (this.isMobile()) {
      this.airportModal.toggleModal(this.changeState);
    } else {
      if (airportType === AIRPORT_FROM) {
        this.setState({
          showDesktopChooseAirportTo: false,
          showDesktopChooseAirportFrom: true,
          inProp: true,
        });
      } else {
        this.setState({
          showDesktopChooseAirportFrom: false,
          showDesktopChooseAirportTo: true,
          inProp: true,
        });
      }
    }
  }

  changeState = () => {
    this.setState({
      viewLP: false
    });
  }

  handleClickDate = (input) => {
    this.toggleShowSidebar;
    this.setPositionArrow(input);

    this.setState({
      showDesktopChooseAirportFrom: false,
      showDesktopChooseAirportTo: false,
      sidebarActive: true,
      viewLP: true,
      inProp: true,
    }, () => {
      this.props.showSidebar(this.state.sidebarActive);
    });

    if (this.isMobile()) {
      this.dateModal.toggleModal();
    } else {
      this.setState({ showDesktopChooseDate: true });
    }
  }

  closeDesktopChooseDate = () => {
    this.setState({
      showDesktopChooseDate: false,
      sidebarActive: false,
      viewLP: false,
      inProp: false,
    }, () => {
      setTimeout(() => {
        this.props.showSidebar(this.state.sidebarActive)
      }, 500);
    })
  }

  addClassContentLp = () => {
    return this.state.showDesktopChooseAirportFrom ||
      this.state.showDesktopChooseAirportTo ||
      this.state.showDesktopChooseDate;
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    if (!this.state.hasMounted) {
      return null;
    }

    const { startDate, endDate, airportFrom, airportTo, locale } = this.props;
    const { viewLP, height, showDesktopChooseAirportFrom,
      showDesktopChooseDate, showDesktopChooseAirportTo, inProp } = this.state;
    const isMobileH = height >= 700;
    var classHeader = "booking-grid grid-layout__item grid-layout__item--desc";
    if (isMobileH) {
      classHeader += ' grid-layout__item--content-center';
    } else {
      classHeader += ' grid-layout__item--content-block';
    }

    return (
      <Fragment>
        <div className={classNames(
          'content', {
          'content--lp': viewLP
        })}
          style={{ padding: 0 }}
        >
          <div className="grid-layout grid-layout--vh" style={{ padding: 0 }}>
            {
              !this.isMobile() &&
              <SidebarArrow
                positionTop={this.state.arrowPosition}
                visible={showDesktopChooseAirportFrom || showDesktopChooseDate || showDesktopChooseAirportTo} />
            }

            <div
              className={classHeader}
              style={{ backgroundColor: '#ffffff', zIndex: 1, boxShadow: 'none' }}>

              {!this.props.onlyMobile &&
                <header className="branding branding--airport">
                  <div className="cloud-top"></div>
                  <div className="cloud-bottom"></div>
                </header>
              }

              <div className="content__desc">
                <header className="head mb-30">
                  <h3><T>content.bookingStep1.header</T></h3>
                  <p><T>content.bookingStep1.whatFlight</T></p>
                </header>

                <form>
                  <fieldset>
                    <legend className="visuallyhidden">Booking Form</legend>

                    <ul className="list-fields list-none mb-15">
                      <li className="list-fields__item">
                        <BookingInput
                          id='fromAirportBooking'
                          name="from-airport-booking"
                          label={this.trans('content.bookingStep1.chooseAirportFrom')}
                          placeholder={this.trans('content.bookingStep1.chooseAirportPlaceholder')}
                          value={airportFrom.label}
                          optional={false}
                          readOnly={true}
                          locale={locale}
                          toggleModal={() => this.handleClickAirport(AIRPORT_FROM, this.inputAirportFrom)}
                          ref={el => this.inputAirportFrom = el}>
                          <FontAwesomeIcon
                            icon={['fas', 'angle-down']}
                            size="lg"
                          />
                        </BookingInput>
                         <Error error={this.state.errors.airportFrom} />
                      </li>
                      <li className="list-fields__item">
                        <BookingInput
                          id='toAirportBooking'
                          label={this.trans('content.bookingStep1.chooseAirportTo')}
                          placeholder={this.trans('content.bookingStep1.chooseAirportPlaceholder')}
                          value={airportTo.label}
                          readOnly={true}
                          optional={false}
                          locale={locale}
                          toggleModal={() => this.handleClickAirport(AIRPORT_TO, this.inputAirportTo)}
                          ref={el => this.inputAirportTo = el}>

                          <FontAwesomeIcon
                            icon={['fas', 'angle-down']}
                            size="lg"
                          />
                        </BookingInput>
                        <Error error={this.state.errors.places} />
                        <Error error={this.state.errors.airportTo} />
                      </li>
                      <li className="list-fields__item">
                        {
                          startDate.label === '' ?
                            <BookingInput
                              id='dateBooking'
                              label={this.trans('content.bookingStep1.chooseSelectDate')}
                              placeholder={this.trans('content.bookingStep1.chooseSelectDatePlaceholder')}
                              readOnly={true}
                              toggleModal={() => this.handleClickDate(this.inputAirportDate1)}
                              ref={el => this.inputAirportDate1 = el}>
                              <FontAwesomeIcon
                                icon={['fas', 'calendar-alt']}
                                size="sm"
                              />
                            </BookingInput>
                            :
                            <div className="selected-date">
                              <BookingInput
                                id='flyOutBooking'
                                label={this.trans('content.flyOut')}
                                className='selected-date__item'
                                value={startDate.label}
                                readOnly={true}
                                toggleModal={() => this.handleClickDate(this.inputAirportDate2)}
                                ref={el => this.inputAirportDate2 = el}>
                              </BookingInput>
                              <BookingInput
                                id='flyBackBooking'
                                label={this.trans('content.flyBack')}
                                className='selected-date__item'
                                value={endDate.label}
                                readOnly={true}
                                toggleModal={() => this.handleClickDate(this.inputAirportDate2)}>
                                <FontAwesomeIcon
                                  icon={['fas', 'calendar-alt']}
                                  size="lg"
                                />
                              </BookingInput>
                            </div>

                        }
                        <Error error={this.state.errors.date} />
                      </li>
                    </ul>

                    <ul className="amount-people">
                      <li className="amount-people__item">
                        <div className="amount-people__label">{this.trans('content.common.adults')}</div>
                        <Counter
                          onChange={this.props.setAdultsNumber}
                          number={this.props.adultsNumber}
                        />
                      </li>

                      <li className="amount-people__item">
                        <div className="amount-people__label">{this.trans('content.common.students')}</div>
                        <Counter
                          onChange={this.props.setStudentsNumber}
                          number={this.props.studentsNumber}
                        />
                      </li>

                      <li className="amount-people__item">
                        <div className="amount-people__label">
                          {this.trans('content.common.kids')}{' '}
                          <span>({this.trans('content.common.under')} 12 y)</span></div>
                        <Counter
                          onChange={this.props.setChildrenNumber}
                          number={this.props.childrenNumber}
                        />
                      </li>
                    </ul>

                    <Error
                      error={this.state.errors.passengers}
                      css={{ margin: '-35px 0 45px 75px' }}
                    />

                    <button
                      className="button button--expand"
                      onClick={this.goNext}
                    >
                      <T>content.bookingStep1.letsGo</T>
                    </button>
                  </fieldset>
                </form>
              </div>
            </div>

            {!this.props.onlyMobile &&
              <div className={
                classNames(
                  'grid-layout__item',
                  'grid-layout__item--info',
                  { 'grid-layout__item--info-center': this.state.sidebarActive }
                )}
              >
                {this.props.layoutLp
                  ?
                  <Fragment>
                    <Transition in={inProp} timeout={duration}>
                      {state => (
                        <div style={{
                          ...defaultStyle,
                          ...transitionStyles[state]
                        }}>
                          {this.state.showDesktopChooseAirportFrom &&
                            <div className="grid-layout__info-sidebar">
                              <div className="grid-layout__info-desc">
                                <div className="info-sidebar__header">
                                  <h4><T>content.bookingStep1.headerChooseAirport</T></h4>
                                </div>
                                <BookingAirports
                                  airports={this.state.airports}
                                  airportType={this.state.airportType}
                                  userSelected={this.onUserSelected}
                                  users={this.state.people}
                                  closeListAirports={() => this.setState({
                                    showDesktopChooseAirportFrom: false,
                                    sidebarActive: false,
                                    viewLP: false,
                                    inProp: false,

                                  }, () => {
                                    setTimeout(() => {
                                      this.props.showSidebar(false)
                                    }, 500);
                                  })}
                                />
                              </div>
                            </div>
                          }

                          {this.state.showDesktopChooseAirportTo &&
                            <div className="grid-layout__info-sidebar">
                              <div className="grid-layout__info-desc">
                                <div className="info-sidebar__header">
                                  <h4><T>content.bookingStep1.headerChooseAirport</T></h4>
                                </div>
                                <BookingAirports
                                  airports={this.state.airports}
                                  airportType={this.state.airportType}
                                  userSelected={this.onUserSelected}
                                  users={this.state.people}
                                  closeListAirports={() => this.setState({
                                    showDesktopChooseAirportTo: false,
                                    sidebarActive: false,
                                    viewLP: false,
                                    inProp: false,
                                  }, () => {
                                    setTimeout(() => {
                                      this.props.showSidebar(false)
                                    }, 500);
                                  })}
                                />
                              </div>
                            </div>
                          }

                          {this.state.showDesktopChooseDate &&
                            <div className="grid-layout__info-sidebar">
                              <div className="grid-layout__info-desc grid-layout__info-desc--calendar">
                                <div className="info-sidebar__header info-sidebar__header--calendar"></div>
                                <div className="calendar-wrap">
                                  <Calendar closeModal={this.closeDesktopChooseDate} />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      )}
                    </Transition>
                  </Fragment>
                  :
                  <FlipMove
                    appearAnimation="accordionHorizontal"
                    delay={0}
                    duration={150}
                    easing="ease-out"
                    enterAnimation="accordionHorizontal"
                    leaveAnimation="accordionHorizontal"
                  >
                    {this.state.showDesktopChooseAirportFrom &&
                      <div key="desktop1" className="grid-layout__info-sidebar">
                        <div className="grid-layout__info-desc">
                          <div className="info-sidebar__header">
                            <h4><T>content.bookingStep1.headerChooseAirport</T></h4>
                          </div>
                          <BookingAirports
                            airports={this.state.airports}
                            airportType={this.state.airportType}
                            userSelected={this.onUserSelected}
                            users={this.state.people}
                            closeListAirports={() => this.setState({
                              showDesktopChooseAirportFrom: false,
                              sidebarActive: false,
                              viewLP: false,
                              inProp: false,

                            }, () => {
                              setTimeout(() => {
                                this.props.showSidebar(false)
                              }, 500);
                            })}
                          />
                        </div>
                      </div>
                    }

                    {this.state.showDesktopChooseAirportTo &&
                      <div key="desktop2" className="grid-layout__info-sidebar">
                        <div className="grid-layout__info-desc">
                          <div className="info-sidebar__header">
                            <h4><T>content.bookingStep1.headerChooseAirport</T></h4>
                          </div>
                          <BookingAirports
                            airports={this.state.airports}
                            airportType={this.state.airportType}
                            userSelected={this.onUserSelected}
                            users={this.state.people}
                            closeListAirports={() => this.setState({
                              showDesktopChooseAirportTo: false,
                              sidebarActive: false,
                              viewLP: false,
                              inProp: false,
                            }, () => {
                              setTimeout(() => {
                                this.props.showSidebar(false)
                              }, 500);
                            })}
                          />
                        </div>
                      </div>
                    }

                    {this.state.showDesktopChooseDate &&
                      <div key="desktop3" className="grid-layout__info-sidebar">
                        <div className="grid-layout__info-desc grid-layout__info-desc--calendar">
                          <div className="info-sidebar__header info-sidebar__header--calendar"></div>
                          <div className="calendar-wrap">
                            <Calendar closeModal={this.closeDesktopChooseDate} />
                          </div>
                        </div>
                      </div>
                    }
                  </FlipMove>
                }
              </div>
            }
          </div>
        </div>

        <BookingModal
          label={this.trans('content.bookingStep1.mobile.selectAirportLabel')}
          title={this.trans('content.bookingStep1.mobile.selectAirportTitle')}
          ref={ref => this.airportModal = ref}
          callbackChangeStateLp={this.changeState}
          modalStyles={{
            overflow: 'hidden'
          }}>
          <BookingAirports
            locale={this.props.locale}
            airports={this.state.airports}
            userSelected={this.onUserSelected} users={this.state.people}
            airportType={this.state.airportType}
            closeListAirports={() => this.airportModal.toggleModal()}
          />
        </BookingModal>

        <BookingModal
          label={this.trans('content.bookingStep1.mobile.selectDate')}
          title={this.trans('content.bookingStep1.mobile.selectDates')}
          ref={ref => this.dateModal = ref}
          calendarModal
          modalStyles={{
            background: '#ffffff',
            overflow: 'hidden'
          }}>
          <Calendar closeModal={() => this.dateModal.toggleModal()} locale={this.props.locale} />
        </BookingModal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    startDate: state.booking.startDate,
    endDate: state.booking.endDate,
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    childrenNumber: state.booking.childrenNumber,
    adultsNumber: state.booking.adultsNumber,
    studentsNumber: state.booking.studentsNumber,
    startFromBooking: state.booking.startFromBooking
  };
};

export default withRouter(
  resizer(
    connect(
      mapStateToProps,
      { setChildrenNumber, setAdultsNumber, showSidebar, startFromBooking, setStudentsNumber }
    )(Booking)
  )
);
